import { render, staticRenderFns } from "./RefuseAction.vue?vue&type=template&id=5fef7737&scoped=true&"
import script from "./RefuseAction.vue?vue&type=script&lang=js&"
export * from "./RefuseAction.vue?vue&type=script&lang=js&"
import style0 from "./RefuseAction.vue?vue&type=style&index=0&id=5fef7737&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fef7737",
  null
  
)

export default component.exports